export function wrap(prefix, suffix, trim = true) {
    return (text, cursorStart, cursorEnd) => {
        const selected = text.slice(cursorStart, cursorEnd);
        return {
            replaceStart: trim
                ? cursorStart + selected.length - selected.trimStart().length
                : cursorStart,
            replaceEnd: trim
                ? cursorEnd - selected.length + selected.trimEnd().length
                : cursorEnd,
            replacement: prefix + (trim ? selected.trim() : selected) + suffix,
            cursorPosition: cursorStart === cursorEnd ? cursorStart + prefix.length : undefined,
        };
    };
}
export function prefixLines(linePrefix) {
    return (text, cursorStart, cursorEnd) => {
        const lineStart = text.lastIndexOf("\n", cursorStart - 1) + 1;
        const rawEnd = text.indexOf("\n", cursorEnd);
        const lineEnd = rawEnd === -1 ? text.length : rawEnd;
        const result = text
            .slice(lineStart, lineEnd)
            .split("\n")
            .map(typeof linePrefix === "string"
            ? (line) => linePrefix + line
            : linePrefix)
            .join("\n");
        return {
            replaceStart: lineStart,
            replaceEnd: lineEnd,
            replacement: result,
        };
    };
}
export const wrapCode = (text, cursorStart, cursorEnd) => {
    if (text.slice(cursorStart, cursorEnd).includes("\n")) {
        return wrap("```\n", "\n```", false)(text, cursorStart, cursorEnd);
    }
    else {
        return wrap("`", "`", false)(text, cursorStart, cursorEnd);
    }
};
//# sourceMappingURL=utils.js.map